import React from 'react'
import styled from '@emotion/styled'

import { fontSizeXSmall, fontSize3XSmall, fontWeightBold } from '../../../constants/principles'
import RadioToggle from '../toggles/radioToggle'
import Comment from './Comment'
import Error from '../Error'
import { QuestionUtils } from '../../../utils/siteUtils'

export default ({
  title,
  subtitle,
  explanation,
  children,
  questionId,
  questionChoices = [],
  selectedIndex,
  question,
  saveQuestionResponse,
  saveQuestionResponseComment,
  getQuestionResponseComment,
  errorMessage,
  fullWidth,
  subTextOverride,
  locked,
  shouldShowCheck
}) => {
  return (
    <>
      {title && (
        <StyledTitle subtitle={!!subtitle} id={questionId && questionId.replace(/\//gi, '-') + '-title'}>
          {title}
        </StyledTitle>
      )}
      {subtitle && <StyledSubTitle>{subtitle}</StyledSubTitle>}
      {children ? (
        children
      ) : (
        <RadioToggle
          uniformSize={false}
          id={questionId}
          testId={questionId}
          selectedIndex={selectedIndex}
          pills={questionChoices} //
          onClickItem={(index, isSelected) => saveQuestionResponse(questionId, index)}
          fullWidth={fullWidth}
          subTextOverride={subTextOverride}
          locked={locked}
          shouldShowCheck={shouldShowCheck}
        />
      )}
      {explanation && <StyledSubTitle>{explanation}</StyledSubTitle>}
      {errorMessage && <Error isError={!!errorMessage} id={questionId.replace(/\//gi, '-') + '-error'} text={errorMessage} />}
      {QuestionUtils.isQuestionAnswered(selectedIndex) && ((questionChoices.length === 1 ? question : question.selectChoices[selectedIndex]) || {}).acceptsComment && (
        <Comment question={question} saveQuestionResponse={saveQuestionResponseComment} getQuestionResponse={getQuestionResponseComment} questionId={questionId} />
      )}
    </>
  )
}

const StyledTitle = styled.p`
  font-size: ${fontSizeXSmall};
  font-weight: ${fontWeightBold};
  margin: 0px;
  width: 100%;
  ${p => !p.subtitle && `padding-bottom:16px;`}
`
const StyledSubTitle = styled.p`
  font-size: ${fontSize3XSmall};
  width: 100%;
`
